// @ts-check

/**
 * Enumerated type for production locations.
 * @type {typeof import('@erpagroapp/types').TipoFinPaletPuntoPaletizado}
 */
export const TipoFinPaletPuntoPaletizado = Object.freeze({
  ManualLecturaBultoABulto: 0,
  ManualLecturaUltimoBulto: 1,
  AutomaticoLecturaYFin: 2,
  AutomaticoSoloFin: 3,
  ManualLecturaUltimoBultoReservado: 4,
});

/**
 * Enumerado para modelo de Entidades
 * Utilizado en entidad/es: PuntoPaletizado
 */
export const ModoPartidaPuntoPaletizado = Object.freeze({
  TodasDelTiempoConfeccionPalet: 0,
  ActivaMomentoInicioPalet: 1,
  ActivaMomentoFinPalet: 2,
  AsignadasIUC: 3,
});

/**
 * Enumerado para clasificiar las diferentes incidencias de una linea de pedido planificada.
 * Se corresponde con el enumerádo de ERP con el mismo nombre.
 */
export const TipoIncidenciaPlanificacionLineaPedidoVenta = Object.freeze({
  AUMENTO: 0,
  DISMINUCION: 1,
  CAMBIOENVASE: 2,
});

export const TipoMovimientoPicking = Object.freeze({
  NC: 0, // No configurado
  TRASPASO: 1,
  REPROCESADO: 2,
});
